'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n    background: #FFFFFF;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n'], ['\n    background: #FFFFFF;\n    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);\n    border-radius: 2px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    div {\n      padding: 20px 0 10px;\n      font-size: 24px;\n      color: ', ';\n    }\n    img {\n      margin-right: 6px;\n    }\n'], ['\n    div {\n      padding: 20px 0 10px;\n      font-size: 24px;\n      color: ', ';\n    }\n    img {\n      margin-right: 6px;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding: 0 26px;\n    div {\n      font-size: 14px;\n      line-height: 19px;\n    }\n'], ['\n    padding: 0 26px;\n    div {\n      font-size: 14px;\n      line-height: 19px;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    margin-left: 16px;\n    margin-right: 16px;\n'], ['\n    margin-left: 16px;\n    margin-right: 16px;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    margin: 25px 26px 30px;\n\n    a {\n      height: 50px;\n      font-size: 16px;\n    }\n\n    ', '\n'], ['\n    margin: 25px 26px 30px;\n\n    a {\n      height: 50px;\n      font-size: 16px;\n    }\n\n    ', '\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n        margin: 15px auto 20px;\n        a, button {\n          height: 35px;\n          font-size: 14px;\n          padding: 1px 20px 0;\n        }\n    '], ['\n        margin: 15px auto 20px;\n        a, button {\n          height: 35px;\n          font-size: 14px;\n          padding: 1px 20px 0;\n        }\n    ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsHelper = require('../../lib/styledComponentsHelper');

var _commonWebLocalization = require('../../localization/commonWebLocalization');

var _commonWebLocalization2 = _interopRequireDefault(_commonWebLocalization);

var _PlaceSuggestField = require('../PlaceSuggestField');

var _PlaceSuggestField2 = _interopRequireDefault(_PlaceSuggestField);

var _dist = require('wendys-common-web-ui/dist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var DeliverySearchStyled = _styledComponents2.default.div(_templateObject);

var TitleStyled = _styledComponents2.default.div(_templateObject2, _dist.theme.findColor('red'));

var BodyStyled = _styledComponents2.default.div(_templateObject3);

var InputStyled = _styledComponents2.default.div(_templateObject4);

var ButtonStyled = _styledComponents2.default.div(_templateObject5, _styledComponentsHelper.media.md(_templateObject6));

var DeliverySearch = function DeliverySearch(props) {
    return _react2.default.createElement(
        DeliverySearchStyled,
        null,
        _react2.default.createElement(
            TitleStyled,
            null,
            _react2.default.createElement(
                _dist.Text,
                { type: 'title' },
                _react2.default.createElement('img', { src: '/images/common/ic_delivery.svg' }),
                _commonWebLocalization2.default.get('delivery_search_title', props.lang, props.cntry)
            )
        ),
        _react2.default.createElement(
            BodyStyled,
            null,
            _react2.default.createElement(
                _dist.Text,
                { type: 'body' },
                _commonWebLocalization2.default.get('delivery_search_body', props.lang, props.cntry)
            )
        ),
        _react2.default.createElement(
            InputStyled,
            null,
            _react2.default.createElement(_PlaceSuggestField2.default, { handleSelectSuggest: props.onSelect,
                googleMaps: props.googleMapsHelper.googleMapsInstance.maps,
                error: props.deliveryUnavailableError
            })
        ),
        _react2.default.createElement(
            ButtonStyled,
            null,
            _react2.default.createElement(
                _dist.Button,
                { primary: !props.redirectUrl,
                    disabled: !props.redirectUrl,
                    href: props.redirectUrl
                },
                props.buttonLabel
            )
        )
    );
};

DeliverySearch.propTypes = {
    googleMapsHelper: _propTypes2.default.object.isRequired,
    onSelect: _propTypes2.default.func,
    buttonLabel: _propTypes2.default.string,
    redirectUrl: _propTypes2.default.string,
    deliveryUnavailableError: _propTypes2.default.string,
    lang: _propTypes2.default.string,
    cntry: _propTypes2.default.string
};

DeliverySearch.defaultProps = {
    onSelect: function onSelect() {},
    buttonLabel: 'GO TO DELIVERY',
    redirectUrl: '',
    deliveryUnavailableError: '',
    lang: 'en',
    cntry: 'US'
};

exports.default = DeliverySearch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/DeliverySearch/index.js
// module id = 792
// module chunks = 0